import {
  InteractionType,
  InteractionStatus,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { msalInstance, authState } from "../index";
import { loginRequest } from "../authConfig";

export async function getUserToken() {
  const scopes = [
    "api://602c6f6a-e5d7-40ef-93bb-9515a9af7862/access_as_user",
      "User.Read",
    ];
    if (!authState.redirectCompleted) return;

    const account = msalInstance.getActiveAccount();
    if (!account) {
        //kein aktiver Account, daher Login erzwingen
        msalInstance.loginRedirect({
            ...loginRequest,
            scopes,
            prompt: "login"
        });
        return; // <- sehr wichtig
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account,
            scopes
        });

        return response;
    }
    catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            msalInstance.loginRedirect({
                ...loginRequest,
                scopes,
                prompt: "login"
            });
            return;
        }
        throw error;
    }
}